/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../actions';
import axios from 'axios';
import collections from '../constants/FirestoreCollections';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    header: {
      background: theme.palette.black.main,
      height: '75px',
    },
    title: {
      color: theme.palette.white.main,
    },
    checkboxLabel: {
      fontWeight: 'bold',
    },
    mainBtn: {
      width: 'fit-content',
      borderRadius: '3rem',
    },
    disableNotifications: {
      color: '#CDBABA',
      fontSize: theme.sizes.sm.t2,
    },
    disableNotificationsLink: {
      color: '#7558D7',
      fontSize: theme.sizes.sm.t1,
      textDecoration: 'underline',
      width: 'fit-content',
      cursor: 'pointer',
      '&:hover': {
        fontSize: 13,
      },
    },
    clientName: {
      fontWeight: 'bold',
      fontSize: 18,
      textTransform: 'uppercase',
    },
    templatesWapiTitle: {
      marginBottom: 8,
      fontSize: 22,
      fontWeight: 'light',
    },
    templatesWapi: {
      textAlign: 'justify',
    },
  }));
};

function TemplatesWapi() {
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  // redux
  // hooks
  const firebase = useFirebase();
  const firestore = useFirestore();
  //   const history = useHistory();
  const appDispatch = useDispatch();
  const projectId = process.env.REACT_APP_PROJECT_ID;

  // states
  const [data, setData] = useState({});

  const search = useLocation().search;
  const msgId = new URLSearchParams(search).get('msgId');

  useEffect(() => {
    if (msgId) {
      firestore
        .collection(collections.gestiones)
        .where('msgId', '==', msgId)
        .get(1)
        .then((res) => {
          let gestion;
          res.forEach((e) => {
            if (e) {
              gestion = { id: e.id, ...e.data() };
            }
          });
        });
    }
  }, [firestore, msgId]);

  const handleSubmit = (res) => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });

    const body = {
      queryResult: {
        queryText: 'CONFIRMAR',
        action: 'confirmar.turno.si(confirmacion)/ confirmar.turno.no (cancelacion)',
        parameters: {},
        fulfillmentText: '',
        fulfillmentMessages: [],
        outputContexts: [],
        intent: {
          displayName: 'GESTION.notificaciones.confirmar_turno',
        },
        payload: { gsid: 'id del mje que se guarda en la gestion' },
      },
      session: 'construir session igual que para chats de wsp',
    };

    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(function (token) {
        axios(`https://us-central1-${projectId}.cloudfunctions.net/genericWebhook`, {
          method: 'POST',
          headers: {
            Authorization: `bearer ${token}`,
          },
          data: { body },
        });
      });

    appDispatch({
      type: actions.alert,
      alert: {},
    });
  };

  return (
    <Box>
      <Box
        className={classes.header}
        display="flex"
        width="100%"
        alignItems="center"
        justifyContent="center"
      >
        <Box mr={2}>
          <img src="/logo512.png" width="50" alt="PrestoBots" />
        </Box>
        <Typography component="h1" variant="h6" noWrap className={classes.title}>
          PrestoBots
        </Typography>
      </Box>
      <Box display="flex" maxWidth="700px" mx="auto" flexDirection="column" p={4}>
        <Box mb={2}>
          <Typography className={classes.templatesWapiTitle}>NOMBRE DE LA CLINICA</Typography>
          <Typography className={classes.templatesWapi}>
            template de confirmacion/cancelacion con los parametros
          </Typography>
        </Box>

        <Box>
          <Box mb={4} />
          <Button
            type="button"
            variant="contained"
            color="success"
            className={classes.mainBtn}
            onClick={handleSubmit()}
          >
            CONFIRMAR TURNO
          </Button>
          <Box ml={2} />
          <Button
            type="button"
            variant="contained"
            color="error"
            className={classes.mainBtn}
            onClick={handleSubmit()}
          >
            CANCELAR TURNO
          </Button>
        </Box>
        <Box />
      </Box>
    </Box>
  );
}

const Props = {};

TemplatesWapi.propTypes = Props;

export default TemplatesWapi;
